import istor from '../Assets/istor2.png';
import ministor from '../Assets/ministor.png';
import { useMediaQuery } from '../useMediaQuery';

const handleLogout = () => {
    document.cookie = 'jwt=;Domain=.istor.io;Path=/;Max-Age=0;SameSite=None;Secure';
    document.cookie = 'refreshJwt=;Domain=.istor.io;Path=/;Max-Age=0;SameSite=None;Secure';
    window.location.href = '/';
};

const TITLE = '“Bienvenue !';
const MESSAGE = 'Votre compte a bien été créé.\nVous apparaîtrez dans la liste \ndes utilisateurs disponibles.\nUn administrateur d’organisation \ndoit vous y ajouter pour que \nvous puissiez accéder au contenu.”';
const SHORT = 'Votre compte a bien été créé. Vous apparaîtrez dans la liste des utilisateurs disponibles. Un administrateur d’organisation doit vous y ajouter pour accéder au contenu.”';

const logoutButton = (
    <button
        className="connexion"
        type="button"
        onClick={handleLogout}
        style={{
            width: '100%',
            height: '36px',
            borderRadius: '10px',
            color: '#FFFFFF',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '13px',
            fontWeight: '600',
            cursor: 'pointer',
        }}
    >
        Se déconnecter
    </button>
);

const NoOrg = () => {
    const isMobile = useMediaQuery('(max-width: 750px)');

    if (isMobile) {
        return (
            <div style={{
                width: '330px',
                height: '517px', maxHeight: 'calc(100dvh - 40px)',
                boxSizing: 'border-box',
                backgroundColor: '#FFFFFF',
                borderRadius: '20px',
                boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
                padding: '20px 30px 30px 30px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}>
                {/* Haut : mini-mascotte + titre + message, aligné à gauche */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <img src={ministor} alt="istor" style={{ width: '60px', height: '60px', borderRadius: '50%', flexShrink: 0 }}/>
                        <div style={{ fontSize: '24px', fontWeight: '600', color: '#173C50' }}>{TITLE}</div>
                    </div>
                    <div style={{
                        marginTop: '10px',
                        whiteSpace: 'pre-line',
                        fontSize: '13px',
                        fontWeight: '400',
                        color: '#173C50',
                        lineHeight: '19px',
                        textAlign: 'left',
                    }}>{SHORT}</div>
                </div>

                {/* Bas : bouton Se déconnecter */}
                <div style={{ width: '100%' }}>{logoutButton}</div>
            </div>
        );
    }

    return (
        <div style={{
            width: '700px',
            height: '450px',
            display: 'flex',
            overflow: 'hidden',
            borderRadius: '20px',
            boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
        }}>
            {/* Left panel */}
            <div style={{
                height: '100%',
                width: '360px',
                backgroundColor: '#173C50',
                position: 'relative',
                color: '#FFFFFF',
                flexShrink: 0,
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    paddingLeft: '30px',
                    left: '0',
                    position: 'absolute',
                    top: '36px',
                }}>
                    <div style={{ fontSize: '24px', fontWeight: '600' }}>
                        {TITLE}
                    </div>
                    <div style={{
                        whiteSpace: 'pre-line',
                        fontSize: '13px',
                        fontWeight: '400',
                        lineHeight: '19px',
                    }}>
                        {MESSAGE}
                    </div>
                </div>
                <img style={{ position: 'absolute', bottom: 0, right: '-20px', width: '325px', height: '260px' }} src={istor} alt="istor" />
            </div>

            {/* Right panel */}
            <div style={{
                width: '340px',
                height: '100%',
                backgroundColor: '#FFFFFF',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '0 35px',
                gap: '20px',
                boxSizing: 'border-box',
            }}>
                <div style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#173C50',
                    lineHeight: '22px',
                }}>
                    Vous n'avez accès à aucune organisation pour l'instant.
                </div>
                <div style={{
                    fontSize: '13px',
                    fontWeight: '400',
                    color: '#7C7C7D',
                    lineHeight: '19px',
                }}>
                    Une fois qu'un administrateur vous aura ajouté à une organisation, vous la verrez apparaître ici après connexion.
                </div>
                <div style={{ marginTop: '10px' }}>{logoutButton}</div>
            </div>
        </div>
    );
};

export default NoOrg;
